import { DataTable } from "@/components/data-table";
import { aboutColumns } from "@/features/about/components/about-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useAboutList } from "@/features/about/hooks/useAboutList";
import ListContent from "@/features/about/components/list-content";

const AboutListPage = () => {
  const { t } = useTranslation();
  const { abouts, page, pageCount, setPage, isLoading, isFetching } =
    useAboutList();

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={aboutColumns(t)}
          data={abouts}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
        />
      </div>
      <ListContent
        data={abouts}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
      />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  return <EmptyTable title={t("modules.about.datatable.no_items")} />;
};

export default AboutListPage;
